import React, { useCallback } from 'react'
import SwiperCore, { Navigation } from 'swiper'
import classnames from 'classnames'

import { useAuthState, useQuery } from 'hooks'
import { apiManager } from 'helpers'

import Spinner from 'components/Spinner'
import ForYouProfiles from 'pages/admin/ForYouProfiles'
import message from 'antd/lib/message'

SwiperCore.use([Navigation])

const AdminDiscover = () => {
  const { user } = useAuthState()
  const { isLoading, data, error, refetch } = useQuery(
    'for-you/admin/profiles',
    apiManager.getAdminForYouProfiles,
    {
      enabled: user.admin,
      refetchOnWindowFocus: false,
    }
  )

  const handleAction = useCallback(async ({ liked, user }) => {
    if (liked) {
      return
    }
    try {
      await apiManager.adminHideProfile(user.id)
      return true
    } catch (error) {
      message.error(error?.message || 'An error occurred, please try again')
    }
  }, [])

  if (!user.admin) {
    return null
  }

  return (
    <div className={classnames('flex flex-col justify-between')}>
      {error ? (
        <p className="text-center text-gray-400 text-2xl">
          Something went wrong. Please, try again later!
        </p>
      ) : isLoading ? (
        <div className="flex-col justify-between h-screen-less-navbar-m md:h-screen-less-navbar flex">
          <div className="w-full flex justify-center items-center text-white flex-grow h-72 md:h-auto">
            <Spinner />
          </div>
        </div>
      ) : (
        data.profiles && (
          <ForYouProfiles
            admin={true}
            profiles={data.profiles}
            onAction={handleAction}
            onReload={refetch}
          />
        )
      )}
    </div>
  )
}

export default AdminDiscover
